import { useEffect, useRef } from 'react';
function usePrevious(value, initialValue) {
    var ref = useRef(initialValue);
    useEffect(function () {
        ref.current = value;
    }, [value]);
    return ref.current;
}
export { usePrevious };
